





























































import UploadBlock from './UploadBlock.vue';
import { Component, Vue, ModelSync, Watch } from 'vue-property-decorator';
import { getAppCountryApi, getPassportOcrAppCountryApi } from '@/api/student-management';

@Component({
  name: 'IntelligentIdentificationDialog',
  components: {
    UploadBlock,
  }
})
export default class extends Vue {
  @ModelSync('dialogVisible', 'changeVisible', { type: Boolean }) public value!: boolean;

  public isNotUpload = true;
  public fkAreaCountryId = '';
  public activeOfficeIdx = 1;
  public companyCountryList = [];
  public otherCountryList = [];
  public type = 'issueFileResolverPassportCn'; // issueFileResolverPassportNational

  private contents: any = {
    hasUploaded: false,
    status: [
      {
        title: 'stuManagement.stuName',
        key: 'nameZh',
        exist: false,
      },
      {
        title: 'stuManagement.stuNameEn',
        key: 'firstName',
        exist: false,
      },
      {
        title: 'stuManagement.stuGender',
        key: 'gender',
        exist: false,
      },
      {
        title: 'stuManagement.stuBirthPlace',
        key: 'cityBirth',
        exist: false,
      },
      {
        title: 'stuManagement.stuPassport',
        key: 'passportNumber',
        exist: false,
      },
    ],
  }

  public mounted() {
    this.getPassportOcrAppCountry();
  }

  public async getPassportOcrAppCountry() {
    try {
      const { data } = await getPassportOcrAppCountryApi();
      this.companyCountryList = data.data.companyCountryList;
      this.otherCountryList = data.data.otherCountryList;
    } catch (error) {
      //
    }
  }

  public handleClickOffice(e: any) {
    const dataset = e.target.dataset;
    if (dataset.idx) {
      this.activeOfficeIdx = Number(dataset.idx);
      this.type = dataset.id !== '3' ? 'issueFileResolverPassportNational' : 'issueFileResolverPassportCn';
    }
  }

  public handleSelectCountry(value: number) {
    if (value) {
      this.activeOfficeIdx = this.companyCountryList.length + 1;
      this.type = value !== 3 ? 'issueFileResolverPassportNational' : 'issueFileResolverPassportCn';
    }
  }

  public handleSetAnalysisStatus(obj: any) {
    const personInfo = obj.personInfo;
    const passportStatus = this.contents.status.map((item: any) => {
      if (personInfo[item.key] !== undefined) {
        item.exist = true;
      }
      return item;
    })
    this.contents.status = passportStatus;
    this.contents.hasUploaded = true;
  }

  public handleContinueTofill() {
    this.close();
    this.$emit('link-to-register');
  }

  public close() {
    this.clearStatus();
    this.$emit('changeVisible', false);
  }

  public clearStatus() {
    const contents = this.contents;
    contents.hasUploaded = false;
    const status = contents.status;
    contents.status = status.map((item: any) => {
      item.exist = false;
      return item;
    })
  }
}
